var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8715 9.10053C11.4248 8.25606 9.87358 7.34041 9.80529 7.30037C9.60596 7.18692 9.39796 7.12685 9.20331 7.12685C8.91388 7.12685 8.67696 7.25944 8.53348 7.50059C8.30657 7.77199 8.02515 8.08922 7.95686 8.13838C7.42829 8.49699 7.01451 8.45628 6.55668 7.99845L4.0015 5.44304C3.54656 4.98811 3.50474 4.56922 3.8609 4.04354C3.91073 3.9748 4.22796 3.69316 4.49936 3.46603C4.67244 3.36303 4.79123 3.20998 4.84329 3.02222C4.91248 2.7724 4.86153 2.47853 4.69824 2.19222C4.65976 2.12637 3.74366 0.574926 2.89965 0.128447C2.74214 0.0450239 2.56462 0.000976562 2.38665 0.000976562C2.09345 0.000976562 1.8176 0.115322 1.61026 0.322433L1.04566 0.886817C0.152696 1.77955 -0.17054 2.79153 0.0844007 3.89449C0.297074 4.8137 0.91685 5.79186 1.92682 6.80161L5.19811 10.0729C6.47638 11.3512 7.69502 11.9994 8.82023 11.9994C8.82023 11.9994 8.82023 11.9994 8.82045 11.9994C9.64801 11.9994 10.4195 11.6477 11.1129 10.9543L11.6773 10.3899C12.0203 10.0471 12.0982 9.52876 11.8715 9.10053Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3dfe03c9.svg";
export { ForwardRef as ReactComponent };